import styled from 'styled-components';

export default styled.div`
  && {
    .lease-renewal {
      height: 66px;
      background-color: #ecffb8;
      padding-left: 75px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .intro-update {
      padding: 41px 65px 14px 65px;
    }
    .section {
      padding: 0px 65px 40px 65px;
      .ant-form-item {
        margin-bottom: 0px;
      }
      .update-lease {
        height: 492px;
        background-color: #eeeeee;
        .lease-statistics {
          padding: 50px 86px;
          .row-statistics {
            display: flex;
            align-items: baseline;
            .input-date {
              width: 171px;
              height: 40px;
            }
            .mg-10 {
              margin-left: 10px;
              margin-right: 10px;
            }
            .ant-picker-large .ant-picker-input > input {
              font-size: 14px !important;
            }
          }
          .mb-30 {
            margin-bottom: 30px;
          }
          .mb-39 {
            margin-bottom: 39px;
          }
          .mb-10 {
            margin-bottom: 10px;
          }
        }
      }
    }
    .table-update-lease {
      padding-top: 65px;
    }
    .confirm-update-lease {
      padding-top: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 100px;
      .btn-cancel {
        width: 148px;
        height: 60px;
        background-color: #c4c4c4;
        color: white;
        text-align: center;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        border: none;
        margin-right: 13px;
      }
      .btn-renew-the-lease {
        background-color: #ff8a00;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        border: none;
        width: 267px;
        color: white;
        text-align: center;
        height: 60px;
      }
    }
  }
`;
